// ============================================
// Content Level Hook - reads/writes user content preference
// Similar pattern to useTheme()
// ============================================

import { useState, useEffect } from 'react';
import type { ContentLevel } from './content';
import { setContentLevel, getContentLevel, userTypeToContentLevel } from './content';

const STORAGE_KEY = 'prtcl-content-level';

// Only beginner is currently selectable (intermediate / advanced are
// greyed out in the picker as "Coming soon"). Migrate any existing
// stored value back to beginner so prior testers don't keep seeing
// advanced copy after the rollout.
function getStoredLevel(): ContentLevel {
  return 'beginner';
}

export function initializeContentLevel() {
  const level = getStoredLevel();
  setContentLevel(level);
}

export function useContentLevel() {
  const [level, setLevel] = useState<ContentLevel>(getStoredLevel);

  useEffect(() => {
    setContentLevel(level);
    try {
      localStorage.setItem(STORAGE_KEY, level);
    } catch {}
  }, [level]);

  return {
    level,
    setLevel,
    isBeginner: level === 'beginner',
    isIntermediate: level === 'intermediate',
    isAdvanced: level === 'advanced',
  };
}
